import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

export const FIRST_REFETCH_INTERVAL = 1000;

export const MAX_ALLOW_DAYS: number = 90;
export const MIN_DATE = DateUtils.subtractDaysFromStartToday(MAX_ALLOW_DAYS);
export const MAX_DATE = new Date();
